var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconClose4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0031 8.9614L1.70644 0.646057L0.646484 1.7084L8.94314 10.0237L0.69384 18.2916L1.75379 19.354L10.0031 11.0861L18.2455 19.347L19.3054 18.2847L11.063 10.0237L19.3528 1.71532L18.2928 0.652981L10.0031 8.9614Z"
  })));
}
export default SvgCommonIconClose4;